(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery, getComputedStyle, rive, bodyScrollLock */

	// window.matchMedia("(max-width: 700px)")
	const documentBodyStyle = getComputedStyle(document.body);
	const lgBreakpoint = documentBodyStyle.getPropertyValue("--lg-breakpoint");
	const transitionPanel = parseFloat(documentBodyStyle.getPropertyValue("--transition-panel"));

	const riveCanvas = $(".js-rive-canvas").get(0);
	const riveUrl = $(riveCanvas).data("url");

	let lazyLoadInstance;

	let windowTop = $(window).scrollTop(); // eslint-disable-line
	let windowHeight = window.innerHeight;
	let windowWidth = document.documentElement.clientWidth;
	let previousWindowWidthForHeight = 0;

	let r;
	let isReseting = false;
	let isActive = false;
	let isTransitioning;
	let lastEvent = false;





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".js-lazy",
			threshold: 500,
		});
	}





// Set Variables in JS
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
	}

	function setBottomScrollbarVariable() {
		const bottomScrollbar = window.innerHeight - document.documentElement.clientHeight;
		document.documentElement.style.setProperty("--bottom-scrollbar", `${bottomScrollbar}px`);
	}

	function set100VHVariable() {
		if (windowWidth !== previousWindowWidthForHeight) {
			previousWindowWidthForHeight = windowWidth;
			document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
		}
	}





// Lock and Unlock Scroll
// -----------------------------------------------------------------------------

	function unlockBody() {
		if (!$("html").hasClass("is-locked")) return;
		$("html").removeClass("is-locked");
		document.documentElement.style.setProperty("--compensate-scrollbar", "0px");
		document.documentElement.style.setProperty("--bottom-scrollbar", "0px");
		bodyScrollLock.clearAllBodyScrollLocks();
	}

	function lockBody(otherScroll = false) {
		if ($("html").hasClass("is-locked")) return;
		$("html").addClass("is-locked");
		setScrollbarWidthVariable();
		setBottomScrollbarVariable();
		let scroll;
		if (otherScroll) {
			scroll = otherScroll;
		} else {
			scroll = (window.matchMedia(`(min-width: ${lgBreakpoint})`).matches && window.matchMedia(`(min-height: 840px)`).matches) ? $(".js-panel-content").get(0) : $(".js-panel-scroll").get(0);
		}
		bodyScrollLock.disableBodyScroll(scroll, {
			reserveScrollBarGap: false,
		});
		document.documentElement.style.setProperty("--compensate-scrollbar", documentBodyStyle.getPropertyValue("--scrollbar"));
	}





// Ater Reset
// -----------------------------------------------------------------------------

	function afterReset() {
		isReseting = false;
		isActive = false;
	}





// Reset
// -----------------------------------------------------------------------------

	function resetScene() {
		// Reset Rive view model active area back to initial state
		if (typeof window !== "undefined" && window.riveVmi) {
			const activeAreaProp = window.riveVmi.number("activeArea");
			activeAreaProp.value = 0;
		}

		isReseting = true;
		lastEvent = false;

		$("html").removeClass("active-panel");
		setTimeout(() => {
			$(".js-panel-content").empty();
			$("html").removeClass("active-zone");
			unlockBody();
			afterReset();
		}, transitionPanel * 1000);
	}

	// Activate reseting state and reset all values
	$(".js-reset, .js-overlay").on("click", (event) => {
		event.preventDefault();
		if (isTransitioning || isReseting) return;
		resetScene();
	});





// Append Zone to Panel
// -----------------------------------------------------------------------------

	function appendZoneToPanel(trigger) {
		if (lastEvent === trigger) return;
		lastEvent = trigger;
		const zone = $(`.js-zones .js-zone[data-trigger='${trigger}']`);

		const zoneClone = zone.clone();
		if (zone.length > 0) {
			lockBody();
			$("html").addClass("active-zone active-panel");
			$(".js-panel-content").empty();
			zoneClone.appendTo(".js-panel-content");
			lazyLoadInstance.update();
			setTimeout(() => {
				isTransitioning = false;
			}, transitionPanel * 1000);

		}
	}





// Listen to Rive Events
// -----------------------------------------------------------------------------

	function onRiveEventReceived(event) {
		const eventData = event;

		if (isTransitioning || isReseting) return;

		isActive = true;
		isTransitioning = true;
		appendZoneToPanel(eventData);
	}





// Reposition if canvas is larger than window
// -----------------------------------------------------------------------------

	function repositionCanvas() {
		if (!window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
			const canvasWidth = $(".js-rive-container").outerWidth();
			if (canvasWidth > windowWidth) {
				$(window).scrollLeft((canvasWidth - windowWidth) / 2);
			}

		}
	}





// Popup
// -----------------------------------------------------------------------------

	function initPopup() {
		const player = new Plyr(document.querySelector('.js-plyr'), {
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
		});

		$(".js-popup-overlay, .js-popup-close").click((event) => {
			event.preventDefault();
			$("html").removeClass("popup-is-open");
			unlockBody();
			setTimeout(() => {
				if (player.playing) {
					player.stop();
				}
			}, transitionPanel * 1000);
		});

		$(".js-watch-video").click((event) => {
			event.preventDefault();
			if ($("html").hasClass("popup-is-open")) {
				$(".js-popup-page-1").fadeOut(transitionPanel * 500, () => {
					$(".js-popup-page-2").fadeIn(transitionPanel * 500);
					player.play();
				});
			} else {
				lockBody();
				$(".js-popup-page-1").hide();
				$(".js-popup-page-2").show();
				$("html").addClass("popup-is-open");
				setTimeout(() => {
					player.play();
				}, transitionPanel * 1000);
			}
		});
	}




// Init Rive
// -----------------------------------------------------------------------------

	function initRive() {
		r = new rive.Rive({
			src: riveUrl,
			canvas: riveCanvas,
			layout: new rive.Layout({
				fit: rive.Fit.Contain,
				alignment: rive.Alignment.Center,
			}),
			stateMachines: ["State Machine 1"],
			autoplay: true,
			autobind: false,
			artboard: "Artboard",
			fitCanvasToArtboardWidth: true,
			fitCanvasToArtboardHeight: true,
			isTouchScrollEnabled: true,
			onLoad: () => {
				$("html").removeClass("is-loading");
				r.resizeDrawingSurfaceToCanvas();
				window.riveInputs = r.stateMachineInputs("State Machine 1");

				const viewModel = r.viewModelByName("ViewModel1");
				const vmi = viewModel.instanceByName("Instance");
				r.bindViewModelInstance(vmi);

				// Expose the view model instance globally so it can be reset elsewhere
				window.riveVmi = vmi;

				const activeAreaProp = vmi.number("activeArea");

				// Listen for changes
				activeAreaProp.on((event) => {
					onRiveEventReceived(event);
				});
			},
		});
	}






// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		windowTop = document.documentElement.scrollTop;
		windowHeight = window.innerHeight;
		windowWidth = document.documentElement.clientWidth;

		if (window.history && window.history.scrollRestoration) {
			window.history.scrollRestoration = "manual";
		}

		initLazyLoad();
		setScrollbarWidthVariable();
		set100VHVariable();
		initRive();
		repositionCanvas();
		initPopup();
	});

	$(window).on("resize", () => {
		windowHeight = window.innerHeight;
		windowWidth = document.documentElement.clientWidth;
		r.resizeDrawingSurfaceToCanvas();
	});

}(jQuery));
